import React, { useEffect } from "react";

export const DeltaWaitScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#202020");
    }, []);

    return (
        <div id="game">
            <h1 id="slov_header">GUARDIANRUNE</h1>

            <div
                className="divtext_slov"
                style={{ color: "white", fontSize: "24px", marginBottom: "16px" }}
            >
                <b>{props.prName}</b>
            </div>

            <div
                className="divtext_slov"
                style={{ color: "white", fontSize: "20px" }}
            >
                Ожидание начала битвы...
            </div>
        </div>
    );
};
